<div (click)="activeModal.close()">
    <ng-lottie [options]="options" [styles]="styles" [width]="size" [height]="size"
        (animationCreated)="animationCreated($event)">
    </ng-lottie>

    <div *ngIf="msg" class="alert alert-danger lottie-alert" role="alert">
        {{ msg }}
    </div>
</div>